import { render, staticRenderFns } from "./WarOrder.vue?vue&type=template&id=770181cc"
import script from "./WarOrder.vue?vue&type=script&lang=js"
export * from "./WarOrder.vue?vue&type=script&lang=js"
import style0 from "./WarOrder.vue?vue&type=style&index=0&id=770181cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports